<template>
  <div class="baterias-wrapper">
    <div class="baterias--vantagens">
      <p class="vantagem--aviso">
        <span class="highlight">Preços válidos a base de troca</span> (devolução
        da bateria esgotada)
      </p>
      <div class="vantagem--list">
        <div class="vantagem">
          <span class="icon icon-time"></span>
          <div>
            <p class="vantagem--title">Entrega</p>
            <p>
              Entrega em até uma hora, com instalação e teste da bateria
              gratuito.
            </p>
          </div>
        </div>
        <div class="vantagem">
          <span class="icon icon-money-1"></span>
          <div>
            <p class="vantagem--title">Pagamento</p>
            <p>O pagamento é feito apenas na entrega da bateria.</p>
          </div>
        </div>
      </div>
    </div>
    <div class="container custom-container">
      <div class="baterias">
        <div
          v-for="(item, index) in baterias"
          :key="index"
          class="baterias--item"
        >
          <h3 class="baterias--modelo">
            {{ item.Nome }}
          </h3>
          <figure class="img-responsive">
            <img :src="urlBaterias + item.Codigo + '/' + item.Arquivo" alt="" />
            <!-- <img src="../assets/bateria-placeholder.png"> -->
          </figure>
          <ul class="baterias--desc">
            <li>
              <div class="baterias--selos">
                <figure
                  class="baterias--selo baterias--selo__powerframe"
                  v-if="checkSelo('2', item.BateriasSelos)"
                >
                  <img src="../assets/selo-powerframe.png" alt="" />
                </figure>
                <figure
                  class="baterias--selo baterias--selo__garantia"
                >
                  <img :src="item.ArquivoVisualizacaoGarantia">
                </figure>
                <figure
                  class="baterias--selo baterias--selo__original"
                  v-if="checkSelo('1', item.BateriasSelos)"
                >
                  <img src="../assets/selo-original.png" alt="" />
                </figure>
                <figure
                  class="baterias--selo baterias--selo__duramais"
                  v-if="checkSelo('5', item.BateriasSelos)"
                >
                  <img src="../assets/selo-dura-mais.png" alt="" />
                </figure>
              </div>
            </li>
            <li class="justify-content-center mt-auto">
              <span class="baterias--preco baterias--preco__avista"
                >R$ {{ item.Valor }}</span
              >
            </li>
            <li class="justify-content-center">
              <span class="baterias--preco baterias--preco__parcela"
                >ou até <strong>{{ parcelas }}x sem juros</strong> de
                <strong>R${{ valorParcelado[index] }}</strong></span
              >
            </li>
            <li class="justify-content-center">
              <button
                class="btn baterias--btn"
                @click="selecionar(item.Codigo)"
              >
                Solicitar entrega
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="baterias--vantagens baterias--vantagens__mobile">
      <p class="vantagem--aviso">
        <span class="highlight">Preços válidos a base de troca</span> (devolução
        da bateria esgotada)
      </p>
      <div class="vantagem--list">
        <div class="vantagem">
          <span class="icon icon-time"></span>
          <div>
            <p class="vantagem--title">Entrega</p>
            <p>
              Entrega em até uma hora, com instalação e teste da bateria
              gratuito.
            </p>
          </div>
        </div>
        <div class="vantagem">
          <span class="icon icon-money-1"></span>
          <div>
            <p class="vantagem--title">Pagamento</p>
            <p>O pagamento é feito apenas na entrega da bateria.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MolBateiras",
  data() {
    return {
      indexSelecionado: -1,
      urlBaterias:
        process.env.NODE_ENV == "production"
          ? "/arquivos/baterias/"
          : "https://www.heliarexpress.com.br/arquivos/baterias/",
    };
  },
  props: {
    baterias: Array,
    parcelas: Number,
  },
  methods: {
    selecionar(cod) {
      sessionStorage.setItem("bateria", cod);
      this.$router.push({ name: "criarPedido" });
    },
    isSelected(index) {
      if (index == this.indexSelecionado) {
        return true;
      } else {
        return false;
      }
    },
    checkSelo(selo, bateriaSelos) {
      return bateriaSelos.some((item) => {
        return item.Codigo == selo;
      });
    },
  },
  filters: {
    checkFilter: function(value) {
      if (value) {
        return "\u2713";
      } else {
        return "-";
      }
    },
    dinheiro: function(value) {
      value = Number(value).toFixed(2);
      value = value.replace(".", ",");
      return value;
    },
    btnText: function(value, index) {
      if (value == index) {
        return "Selecionada";
      } else {
        return "Selecionar";
      }
    },
  },
  computed: {
    valorParcelado: function() {
      var precisao = Math.pow(10, 2),
        parcelas = this.baterias.map((item) => {
          var valor = item.Valor;
          valor = valor.replace(/\./g, "");
          valor = parseFloat(valor.replace(",", "."));
          valor = (valor * 10) / this.parcelas / 10;
          valor =
            Math.ceil(parseFloat((valor * precisao).toFixed(2))) / precisao;
          valor = valor.toFixed(2).replace(".", ",");
          valor = valor.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
          return valor;
        });
      return parcelas;
    },
  },
  watch: {
    baterias() {
      this.indexSelecionado = -1;
    },
  },
};
</script>

<style lang="scss">
.baterias {
  display: flex;
  justify-content: center;
  padding-top: 84px;
  padding-bottom: 84px;
  flex-wrap: wrap;
  color: $cinza-escuro;
  &--selos {
    display: flex;
    align-items: center;
    max-width: 100%;
  }
  &--selo {
    margin-right: 22px;
    margin-bottom: 42px;
    &:last-child {
      margin-right: 0;
    }
    &__powerframe {
      width: 55px;
    }
    &__garantia {
      width: 40px;
    }
    &__original {
      width: 75px;
    }
    &__duramais {
      width: 80px;
    }
    img {
      max-width: 100%;
      height: auto;
    }
  }
  &--item {
    padding: 28px;
    border-radius: 10px;
    flex-basis: 375px;
    margin: 0 22px 22px 22px;
    display: flex;
    flex-direction: column;
    background-color: $second-bg-color;
    box-shadow: 0px 1px 4px 0px rgba(12, 12, 13, 0.1),
      0px 1px 4px 0px rgba(12, 12, 13, 0.05);
    .img-responsive {
      text-align: center;
      width: 268px;
      max-width: 100%;
      margin-left: auto;
      margin-right: auto;
      img {
        max-width: 100%;
        height: auto;
      }
    }
  }
  &--modelo {
    font-size: 22px;
    font-weight: 900;
    font-style: italic;
    text-align: center;
    text-transform: uppercase;
    margin-bottom: 28px;
    span {
      display: block;
    }
  }
  &--desc {
    list-style: none;
    padding-left: 0;
    margin-bottom: 0;
    height: 100%;
    display: flex;
    flex-direction: column;
    li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 28px;
      font-weight: 300;
      &:last-child {
        margin-top: 20px;
      }
    }
  }
  &--atributos {
    font-weight: bold;
    &.check {
      color: $black;
    }
  }
  &--preco {
    line-height: normal;
    text-align: center;
    font-weight: normal;
    &__parcela {
      color: $cinza-escuro;
      font-size: 15px;
      text-align: left;
      strong {
        font-weight: 600;
      }
    }
    &__avista {
      font-weight: 900;
      color: $verde-heliar;
      font-style: italic;
      font-size: 36px;
      small {
        font-weight: 900;
        font-size: 14px;
      }
    }
  }
  &--vantagens {
    margin: 84px auto 0;
    padding-top: 42px;
    padding-bottom: 42px;
    background-color: $verde-heliar;
    &__mobile {
      display: none;
    }
    .vantagem {
      display: flex;
      width: 325px;
      align-items: flex-start;
      color: $cinza-escuro;
      font-size: 15px;
      line-height: normal;
      margin-right: 84px;
      &:last-child {
        margin-right: 0;
      }
      p {
        margin-bottom: 0;
      }
      &--title {
        font-weight: 600;
        margin-bottom: 0;
      }
      .icon {
        font-size: 40px;
        width: 60px;
        flex-basis: 60px;
        height: 60px;
        flex-shrink: 0;
        color: $verde-heliar;
        margin-right: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: $white;
        border-radius: 50%;
        line-height: 0;
      }
      &--list {
        display: flex;
        width: 100%;
        justify-content: center;
      }
      &--aviso {
        text-align: center;
        font-size: 22px;
        font-weight: 300;
        font-style: italic;
        margin-bottom: 36px;
        text-transform: uppercase;
        line-height: normal;
        .highlight {
          font-weight: 800;
        }
      }
    }
  }
  .baterias {
    &--btn {
      color: $white;
      background-color: $cinza-escuro;
      width: 100%;
      font-weight: 700;
      font-size: 16px;
      padding: 16px;
      line-height: normal;
      &:hover {
        color: $white;
      }
    }
  }
}
@media (max-width: 1200px) {
  .baterias {
    &--item {
      flex-basis: 340px;
      margin: 0 14px 22px 14px;
    }
    &--selo {
      margin-right: 18px;
      &__powerframe {
        width: 50px;
      }
      &__original {
        width: 70px;
      }
      &__duramais {
        width: 70px;
      }
    }
  }
}
@media (max-width: 991px) {
  .baterias {
    &--vantagens {
      display: none;
      padding: 49px 72px 49px 72px;
      .vantagem {
        margin-right: 0;
        margin-bottom: 62px;
        width: 100%;
        &:last-child {
          margin-bottom: 0;
        }
        &--aviso {
          font-size: 44px;
          margin-bottom: 56px;
        }
        &--list {
          flex-direction: column;
          align-items: center;
        }
        .icon {
          font-size: 59px;
          flex-basis: 91px;
          height: 91px;
          margin-right: 21px;
        }
        &--title {
          font-size: 28px;
        }
        p {
          font-size: 28px;
        }
      }
      &__mobile {
        display: block;
      }
    }
    &--item {
      flex-basis: 100%;
      margin: 0 0 56px 0;
      padding: 42px;
      border-radius: 15px;
      max-width: 100%;
      &:last-child {
        margin-bottom: 0;
      }
      .img-responsive {
        margin: 0 auto;
        width: 523px;
      }
    }
    &--modelo {
      font-size: 44px;
      margin-bottom: 42px;
    }
    &--selo {
      margin-right: 35px;
      margin-bottom: 85px;
      &__powerframe {
        width: 108px;
        img {
          width: 108px;
        }
      }
      &__garantia {
        width: 84px;
        img {
          width: 84px;
        }
      }
      &__original {
        width: 150px;
        img {
          width: 150px;
        }
      }
      &__duramais {
        width: 151px;
        img {
          width: 151px;
        }
      }
    }
    &--preco {
      &__avista {
        font-size: 57px;
        margin-bottom: 14px;
      }
      &__parcela {
        font-size: 28px;
        margin-bottom: 78px;
      }
    }
    .baterias {
      &--btn {
        font-size: 28px;
        padding: 25px 0 25px 0;
        border-radius: 15px;
      }
    }
  }
}
@media (max-width: 767px) {
  .baterias {
    &--vantagens {
      .vantagem {
        &--title {
          font-size: 20px;
        }
        p {
          font-size: 20px;
        }
        &--aviso {
          font-size: 34px;
        }
        .icon {
          flex-basis: 70px;
          height: 70px;
          font-size: 48px;
        }
      }
    }
    &--selo {
      margin-right: 20px;
      &__powerframe {
        width: 80px;
        img {
          width: 80px;
        }
      }
      &__garantia {
        width: 60px;
        img {
          width: 60px;
        }
      }
      &__original {
        width: 110px;
        img {
          width: 110px;
        }
      }
      &__duramais {
        width: 110px;
        img {
          width: 110px;
        }
      }
    }
  }
}
@media (max-width: 575px) {
  .baterias {
    &--vantagens {
      padding: 30px 50px 30px 50px;
      .vantagem {
        margin-bottom: 40px;
        .icon {
          flex-basis: 45px;
          height: 45px;
          font-size: 34px;
        }
        &--aviso {
          font-size: 22px;
        }
        &--title {
          font-size: 16px;
        }
        p {
          font-size: 16px;
        }
      }
    }
    &--item {
      padding: 25px;
    }
    &--selo {
      margin-right: 15px;
      margin-bottom: 40px;
    }
    &--modelo {
      font-size: 28px;
      margin-bottom: 35px;
    }
    &--preco {
      &__avista {
        font-size: 36px;
        margin-bottom: 10px;
      }
      &__parcela {
        font-size: 18px;
        margin-bottom: 40px;
      }
    }
    .baterias {
      &--btn {
        font-size: 18px;
      }
    }
  }
}
</style>
